const middleware = {}

middleware['authcheck'] = require('../../../middleware/authcheck.js')
middleware['authcheck'] = middleware['authcheck'].default || middleware['authcheck']

middleware['en/home'] = require('../../../middleware/en/home.js')
middleware['en/home'] = middleware['en/home'].default || middleware['en/home']

middleware['hem'] = require('../../../middleware/hem.js')
middleware['hem'] = middleware['hem'].default || middleware['hem']

middleware['layout'] = require('../../../middleware/layout.js')
middleware['layout'] = middleware['layout'].default || middleware['layout']

middleware['route'] = require('../../../middleware/route.js')
middleware['route'] = middleware['route'].default || middleware['route']

middleware['test'] = require('../../../middleware/test.js')
middleware['test'] = middleware['test'].default || middleware['test']

export default middleware
